var map = {
	"./Email.svg": 655,
	"./Group.svg": 656,
	"./Layer.svg": 657,
	"./Vector.svg": 1043,
	"./android.svg": 1044,
	"./butterfly.svg": 658,
	"./certificate.svg": 1045,
	"./difficulty-english.svg": 1046,
	"./doublequote.svg": 376,
	"./down-swirly.svg": 1047,
	"./girls.svg": 659,
	"./graphic.svg": 1048,
	"./lang.svg": 660,
	"./learn-python.svg": 1049,
	"./leftquote.svg": 377,
	"./linkedin.svg": 1050,
	"./livelessons.svg": 661,
	"./main_image.svg": 662,
	"./misc.svg": 1051,
	"./misce.svg": 1052,
	"./never-typed.svg": 1053,
	"./playstore.svg": 1054,
	"./python.svg": 1055,
	"./scale.svg": 663,
	"./scratch.svg": 1056,
	"./twitter.svg": 1057,
	"./typeing.svg": 1058,
	"./typing.svg": 1059,
	"./web-development.svg": 1060,
	"./whatsapp.svg": 664
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1042;